import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from "@angular/core"
@Component({
  selector: "ag-button-v2",
  templateUrl: "./ag-button-v2.component.html",
  styleUrls: ["./ag-button-v2.component.scss"],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false,
})
export class AgButtonV2Component implements OnChanges, OnInit {
  @HostBinding("style.pointer-events") get pEvents(): string {
    return this.disabled ? "none" : "auto"
  }
  @Input() public blackImg: boolean //if you want a white image this needs to be set to true.
  @Input() public label: string
  @Input() public labelColor: string
  @Input() public backgroundColor: string // overwrite design system for custom color
  @Input() public imagePath: string
  @Input() public imagePlacement: ImgPlacement = "right"
  @Input() public disabled: boolean
  @Input() public size: AgSize = "medium"
  @Input() public state: AgState = "active"
  @Input() public type: ButtonVersion = "primary"
  @Input() public loading: boolean = false
  @Input() public isLoadable: boolean = false
  @Input() public specificWidth: string
  @Input() public imgSize: string
  @Input() public destructive: boolean = false
  @Input() public loadReplaceLabel: boolean = false
  @Input() public subLabel: string
  @Input() public border: string
  @Input() public removePadding: boolean = false //Override padding, usually for icon or tertiary buttons
  @Input() public specificPadding: string = null //Override padding with specific value
  @Input() public previewButton: boolean = false // Special styling for preview buttons

  public disable: boolean = false

  constructor() {
    this.disable = this.disabled || false
  }
  ngOnInit(): void {
    this.disable = this.disabled || false
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.disabled?.firstChange) {
      this.disable = changes?.disabled?.currentValue
    }
  }
}

export type ImgPlacement = "left" | "right"
export type ButtonVersion = "primary" | "secondary" | "tertiary"
export type AgSize = "large" | "medium" | "small"
export type AgState = "active" | "hover" | "pressed" | "inactive"
